import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';

import { ButterPageType } from '@app/content/models';
import { ButterService } from '@app/content/services';

export const butterPageResolver: ResolveFn<unknown> = (route: ActivatedRouteSnapshot): Observable<unknown> => {
  const type: ButterPageType = route.data['pageType'];
  const slug: string = route.data['pageSlug'] || route.params['slug'];

  return inject(ButterService)
    .page<unknown>(type, slug)
    .pipe(
      map(({ data }) => data.fields),
      catchError(() => of(void 0))
    );
};

export const butterCollectionResolver: ResolveFn<unknown> = (route: ActivatedRouteSnapshot): Observable<unknown> => {
  const slug: string = route.data['collectionSlug'];

  return inject(ButterService)
    .collection(slug)
    .pipe(map(({ data }) => data[slug]));
};
